/* eslint-disable no-shadow */
import Duck from 'extensible-duck';
import _get from 'lodash/get';
import {
  LOADING_INIT_DATA,
  LOAD_DATA_DYNAMIC_SUCCESS,
  LOAD_DATA_FULL_SUCCESS,
  LOAD_INIT_DATA_SUCCESS,
} from '../actions/api-actions';
import {
  getDynamicAndStaticData,
  isExpiredTrip,
  isInvalidTrip,
  isSingleTrip,
} from '../common/utils/trip';

const initialState = {
  status: '',
  itemType: 0,
  expectationId: 0,
  eta: {
    time: null,
    description: '',
    endTime: null,
    schedule: null,
  },
  origin: null,
  destinations: [],
  orderId: '',
  orderBookingCode: '',
  payment: {
    deliveryFee: '',
    cod: '',
    total: '',
    symbol: '',
    payOnDelivery: null,
  },
};

export default new Duck({
  namespace: 'ge-delivery',
  store: 'trip',
  initialState,
  selectors: duck => ({
    trip: state => state[duck.store],
  }),
  reducer: (state, action) => {
    switch (action.type) {
      case LOADING_INIT_DATA:
        return initialState;

      case LOAD_DATA_DYNAMIC_SUCCESS: {
        const { data } = action;

        if (isInvalidTrip(data) || isExpiredTrip(data)) return state;
        const { webTrackingDetails } = data;

        const { dynamicData, staticData } = getDynamicAndStaticData(
          webTrackingDetails[0],
        );
        const {
          orderStatus,
          codPaymentStatus,
          photoProof,
          contextualType,
        } = dynamicData;

        const tripOrigin = {
          ...state.origin,
          proof: photoProof,
        };

        const tripDestinations = [
          {
            ...state.destinations[0],
            proof: photoProof,
          },
        ];

        const eta = {
          time: dynamicData.eta * 1000,
          description: dynamicData.etaDescription,
          endTime: dynamicData.timeStamp * 1000,
          schedule: staticData.schedule,
        };

        if (isSingleTrip(data)) {
          return {
            ...state,
            status: orderStatus,
            codPaymentStatus,
            expectationId: contextualType,
            eta,
            origin: tripOrigin,
            destinations: tripDestinations,
          };
        }

        // MSD
        webTrackingDetails.slice(1).forEach((webTrackingDetail, index) => {
          const { dynamicData } = getDynamicAndStaticData(webTrackingDetail);
          const { photoProof } = dynamicData;

          tripDestinations.push({
            ...state.destinations[index + 1],
            proof: photoProof,
          });
        });

        return {
          ...state,
          status: orderStatus,
          codPaymentStatus,
          expectationId: contextualType,
          eta,
          origin: tripOrigin,
          destinations: tripDestinations,
        };
      }

      case LOAD_INIT_DATA_SUCCESS:
      case LOAD_DATA_FULL_SUCCESS: {
        const { data } = action;

        if (isInvalidTrip(data) || isExpiredTrip(data)) return state;
        const { webTrackingDetails } = data;

        const { staticData, dynamicData } = getDynamicAndStaticData(
          webTrackingDetails[0],
        );
        const {
          itemType,
          cashDeliveryFee,
          totalCashAmount,
          cod_amount,
          orderBookingCode,
          currency,
          payOnDelivery,
        } = staticData;
        const symbol = _get(staticData, 'currency.symbol', '');

        const { origin, destination } = staticData.delivery;
        const {
          orderStatus,
          codPaymentStatus,
          photoProof,
          contextualType,
        } = dynamicData;

        const tripOrigin = {
          name: origin.name,
          address: origin.address,
          instruction: origin.instruction,
          proof: photoProof,
        };

        const eta = {
          time: dynamicData.eta * 1000,
          description: dynamicData.etaDescription,
          endTime: dynamicData.timeStamp * 1000,
          schedule: staticData.schedule,
        };

        const tripDestinations = [
          {
            name: destination.name,
            address: destination.address,
            instruction: destination.instruction,
            proof: photoProof,
          },
        ];

        if (isSingleTrip(data)) {
          return {
            ...state,
            status: orderStatus,
            codPaymentStatus,
            itemType,
            expectationId: contextualType,
            eta,
            origin: tripOrigin,
            destinations: tripDestinations,
            orderId: staticData.orderID,
            orderBookingCode,
            payment: {
              cod: cod_amount,
              deliveryFee: cashDeliveryFee,
              total: totalCashAmount,
              symbol,
              currency,
              payOnDelivery,
            },
          };
        }

        // MSD
        webTrackingDetails.slice(1).forEach(webTrackingDetail => {
          const { staticData, dynamicData } = getDynamicAndStaticData(
            webTrackingDetail,
          );
          const { destination } = staticData.delivery;
          const { photoProof } = dynamicData;

          tripDestinations.push({
            name: destination.name,
            address: destination.address,
            instruction: destination.instruction,
            proof: photoProof,
          });
        });

        return {
          ...state,
          status: orderStatus,
          codPaymentStatus,
          itemType,
          expectationId: contextualType,
          eta,
          origin: tripOrigin,
          destinations: tripDestinations,
          orderId: staticData.orderID,
          payment: {
            cod: cod_amount,
            deliveryFee: cashDeliveryFee,
            total: totalCashAmount,
            symbol,
            currency,
            payOnDelivery,
          },
          orderBookingCode,
        };
      }

      default:
        return state;
    }
  },
});
